import SectionTitle from "../components/SectionTitle";
import SubTitle from "../components/SubTitle";
import Timeline from "../components/Timeline";
import EducationIcon from "../components/icons/EducationIcon";
import { motion } from "framer-motion";
import Modal from "../components/Modal";
import { certificates } from "../data/education-data";
import { educationData } from "../data/education-data";
import { Link } from "react-router-dom";
import { FaExternalLinkAlt } from "react-icons/fa";
import { useEffect } from "react";

export default function EducationSection() {
  useEffect(() => {
    const hash = window.location.hash; // Get the URL hash
    if (hash) {
      const element = document.querySelector(hash); // Find the element with the ID from the hash
      if (element) {
        element.scrollIntoView({ behavior: "smooth" }); // Scroll to the element smoothly
      }
    }
  }, []);

  return (
    <motion.section
      initial={{ x: "-100%" }}
      animate={{ x: 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className="w-full py-5 px-3 sm:px-5"
      id="education"
    >
      <SectionTitle title="Education">
        <EducationIcon />
      </SectionTitle>
      <Timeline
        timelineIcon={<EducationIcon />}
        styleItemLevel="education-icon"
        items={educationData}
      />

      <SubTitle title="Certificates" />

      <div className="flex flex-wrap justify-center gap-4" id="certificates">
        {certificates.map((certificate, index) => (
          <Modal key={index}>
            <div className="m-0 flex flex-col gap-2 border-2 border-solid border-portfolio-line bg-portfolio-page p-2 box-border hover:scale-110 hover:bg-portfolio-surface">
              <Modal.Open opens={`${certificate}-${index}`}>
                <img
                  className="h-[170px] w-[220px] cursor-pointer box-border"
                  src={certificate.image}
                  alt={certificate.image}
                />
              </Modal.Open>
              <Link
                className="flex items-center justify-center gap-[0.2rem] text-[0.8rem] text-portfolio-text no-underline hover:text-portfolio-accent"
                to={certificate.link}
                target="_blank"
              >
                View Credential
                <FaExternalLinkAlt />
              </Link>
            </div>

            <Modal.Window name={`${certificate}-${index}`}>
              <img
                className="max-h-[80vh] max-w-[700px] max-[1024px]:w-full"
                src={certificate.image}
                alt={certificate.image}
              />
            </Modal.Window>
          </Modal>
        ))}
      </div>
    </motion.section>
  );
}
